//
// BooleanMetadataField
//
// A yes/no toggle.

import { observer } from 'mobx-react-lite'

import { HView, Spacer } from '../../appview'
import { BooleanInput } from '../../components'

export const BooleanMetadataField = observer(function BooleanMetadataField(props) {
    const {
        className,
        field,
        fieldname,
        fieldpath,
        item,
        language,
        renderkey,
        onChange,
        ...other
    } = props

    let classes = 'cc-Field cc-BooleanField cc-BooleanMetadataField ws-text'
    if (className) classes += ' ' + className

    const fieldvalue = field.is_localized ? field.value[language] : field.value

    const onSetValue = newValue => {
        const metadatafield = item.metadata.get(fieldpath)
        item.setMetadataField(
            fieldpath,
            metadatafield.type,
            metadatafield.is_localized,
            newValue,
            language
        )
        onChange && onChange(item)
    }

    return (
        <HView className={classes} {...other}>
            <BooleanInput value={fieldvalue} onSetValue={onSetValue} />
            <Spacer grow />
        </HView>
    )
})
